export interface CommonUrls {
  viewInvoices: string;
  viewReceipts: (companyId?: string) => string;
  invoiceDetails: (receiptId: string, poId: string) => string;
  receiptDetails: (receiptId: string, poId: string, isEnterReceipts?: boolean) => string;
  poDetails: (poId: string) => string;
  enterReceipt: (poNumber: string, companyId: string) => string;
  enterInvoice: (
    companyId: string,
    docNumber?: string,
    poNumber?: string,
    isOcrRedirect?: boolean,
    attachId?: string
  ) => string;
  varianceDetails: (poId: string, varianceId: string) => string;
  variances: string;
  createPo: string;
  manageSupplier: string;
  accrual: string;
  checkbook: string;
  catalogMarketplace: string;
  proxyUser: (clientIdEncrypted: string, clientId: string, companyId: string) => string;
  messageDetails: (messageId: string) => string;
}

interface RedirectUrls {
  reactUrls: CommonUrls;
  devUrls: CommonUrls;
}

const appUrl = process.env.REACT_APP_LEGACY_URL;

export const redirectUrls: RedirectUrls = {
  reactUrls: {
    viewInvoices: '/view-invoices',
    viewReceipts: (companyId) => `/view-receipts${companyId ? '?companyId=' + companyId : ''}`,
    invoiceDetails: (receiptId, poId) => `/invoicedetails?recid=${receiptId}&poid=${poId}`,
    receiptDetails: (receiptId, poId, isEnterReceipts) =>
      `/po/receiptdetails?recid=${receiptId}&poid=${poId}${
        isEnterReceipts ? '&from=enter_receipts' : ''
      }`,
    poDetails: (poId) => `${appUrl}/Buyer/PurchaseOrder/Detail?id=${poId}`,
    enterReceipt: (poNumber, companyId) =>
      `/create-receipt?poNumber=${poNumber}&companyId=${companyId}`,
    enterInvoice: (companyId?, docNumber?, poNumber?, isOcrRedirect?, attachId?) =>
      `/enter-invoice?companyId=${companyId}${docNumber ? '&docNumber=' + docNumber : ''}${
        poNumber ? '&poNumber=' + poNumber : ''
      }${isOcrRedirect ? '&isOcrRedirect=' + isOcrRedirect : ''}${
        attachId ? '&attachId=' + attachId : ''
      }`,
    varianceDetails: (poId, varianceId) =>
      `/variance-details?poId=${poId}&varianceId=${varianceId}`,
    createPo: `${appUrl}/Buyer/OfflinePurchaseOrder/CreateOfflinePO`,
    manageSupplier: `${appUrl}/Buyer/OfflinePurchaseOrder/ManageSupplier`,
    variances: `/variances`,
    accrual: `${appUrl}/Buyer/Reports/Accrual`,
    checkbook: '/view-checkbook',
    catalogMarketplace: `${appUrl}/Buyer/Catalog/Marketplace`,
    proxyUser: (clientIdEncrypted, clientId, companyId) =>
      `${appUrl}/Account/ProxyUser/?ClientIdEncrypted=${clientIdEncrypted}&ClientId=${clientId}&CompanyID=${companyId}`,
    messageDetails: (messageId) => `/message-details?recid=${messageId}`,
  },

  devUrls: {
    viewInvoices: '/Buyer/Invoices/ViewInvoices',
    viewReceipts: (companyId?: string) =>
      `/buyer/Receiving/ViewReceipts${companyId ? '?companyId=' + companyId : ''}`,
    invoiceDetails: (receiptId, poId) =>
      `/buyer/invoices/invoicedetails?poid=${poId}&recid=${receiptId}`,
    receiptDetails: (receiptId, poId, isEnterReceipts) =>
      `/buyer/receiving/receiptdetails?recid=${receiptId}&poid=${poId}${
        isEnterReceipts ? '&from=enter_receipts' : ''
      }`,
    poDetails: (poId) => `/Buyer/PurchaseOrder/Detail?id=${poId}`,
    enterReceipt: (poNumber, companyId) =>
      `/Buyer/Receiving/EnterReceipt?poNumber=${poNumber}&companyId=${companyId}`,
    enterInvoice: (companyId?, docNumber?, poNumber?, isOcrRedirect?, attachId?) =>
      `/Buyer/Invoices/EnterInvoice?companyId=${companyId}${
        docNumber ? '&docNumber=' + docNumber : ''
      }${poNumber ? '&poNumber=' + poNumber : ''}${
        isOcrRedirect ? '&isOcrRedirect=' + isOcrRedirect : ''
      }${attachId ? '&attachId=' + attachId : ''}`,
    varianceDetails: (poId, varianceId) =>
      `/buyer/receiving/variancedetails?poId=${poId}&varianceId=${varianceId}`,
    createPo: '/Buyer/OfflinePurchaseOrder/CreateOfflinePO',
    manageSupplier: '/Buyer/OfflinePurchaseOrder/ManageSupplier',
    variances: `/Buyer/Receiving/Variances`,
    accrual: `/Buyer/Reports/Accrual`,
    checkbook: '/Buyer/Checkbook',
    catalogMarketplace: '/Buyer/Catalog/Marketplace',
    proxyUser: (clientIdEncrypted, clientId, companyId) =>
      `/Account/ProxyUser/?ClientIdEncrypted=${clientIdEncrypted}&ClientId=${clientId}&CompanyID=${companyId}`,
    messageDetails: (messageId) => `/Buyer/Messages/MessageDetails?recid=${messageId}`,
  },
} as const;
